import React, {useEffect, useState} from 'react';
import useSWR from "swr";
import {getHttpClient, swrFetcher} from "../../utils/api.ts";
import {Link} from "wouter";
import RenderPlatformIcon from "../../components/RenderPlatformIcon.tsx";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import Button from "../../components/form/Button.tsx";
import SwitchSmall from "../../components/form/SwitchSmall.tsx";
import WorkspaceHome from "../workspace/WorkspaceHome.tsx";
import SettingsSection from "../../components/SettingsSection.tsx";
import Avatar from "../../components/Avatar.tsx";
import Input from "../../components/form/Input.tsx";
import Spinner from "@/components/spinner.tsx";
import Modal from "@/components/Modal.tsx";
import {closeModal, openModal} from "@/components/dispatch_functions.ts";
import AvatarWithUploader from "@/components/AvatarWithUploader.tsx";

function SettingsIndex() {
    return (
        <div>
            <h1 className={"text-3xl"}>Settings</h1>
            <MyProfile />
            <SettingsSection title={"Workspace"} subtitle={"Create and manage your workspaces for separation of concerns and maximum productivity"}>
                <WorkspaceHome />
            </SettingsSection>
            <SettingsSection title={"Connected Accounts"} subtitle={"Connect your social media accounts to post to them"}>
                <ConnectedAccounts />
            </SettingsSection>
            <TermsAndStuff />
        </div>
    );
}

function MyProfile(){
    const {data, mutate} = useSWR('/me', swrFetcher);
    const user = data?.user;
    const name = user?.profile?.name;
    const email = user?.email_or_phone;
    const picture = user?.profile?.picture?.url;
    const [n, setN] = useState('')
    const [p, setP] = useState(null)
    useEffect(() => {
        setN(name)
        setP(picture)
    }, [name, picture]);
    const [saving, setSaving] = useState(false)
    const onSubmit = ()=>{
        setSaving(true)
        getHttpClient().patch('/me',{
            name: n,
            picture: p ? {
                url: p
            } : undefined,
        }).then(()=>{
            mutate()
            setSaving(false)
            closeModal('update-profile')
        })
    }
    return <SettingsSection title={"My Profile"} subtitle={"Update your profile information"}>
        <Modal
            id={"update-profile"}
            onSubmit={onSubmit}
            confirmLoading={saving}
            okText={"Update"}
            title={"Update profile"}>
            <div className={"flex-center mb-3"}>
                <AvatarWithUploader alt={name || email || ' '}
                        onUpload={({url})=>setP(url)}
                        src={p} size={180} />
            </div>
            <Input label={"Name"} value={n} onChange={setN} />
        </Modal>
        <div className="p-3 relative shadow rounded-lg border border-base-200">
        <button onClick={()=>openModal('update-profile')} className={"absolute top-1 end-1 p-3"}><FiEdit2 /></button>
        <div className="flex flex-col items-center">
            <div className="mb-1">
                <Avatar alt={name || email || ' '} src={picture} size={180}/>
            </div>
            <div className={"fs-5"}>{name}</div>
            <div>{email}</div>
        </div>
        </div>
    </SettingsSection>

}

function TermsAndStuff() {
    return <div className={"text-center mt-4"}>
        <small className="block mb-2">
            <Link to={"/legal/tos"}>Terms and Conditions</Link>
        </small>
        <small className="block">
            <Link to={"/legal/privacy"}>Privacy Policy</Link>
        </small>
    </div>
}


function ConnectedAccounts(){
    const {data, isLoading, mutate} = useSWR('/accounts', swrFetcher);
    const [refreshing, setRefreshing ] = useState(false)
    const refresh = ()=>{
        setRefreshing(true)
        getHttpClient().post('/oauth/accounts/refresh')
            .then(()=>{
                setRefreshing(false)
            })
    }
    const toggleAccount = (item, newState: boolean)=>{
        const status =
            newState ? 'active' : 'disabled';
        // item.status === "active" ? 'disabled' : 'active';
        return getHttpClient().patch(`/accounts/${item.id}`,{
            status
        }).then(({data: {success}})=> {
            if (success) {
                item.status = status
                return {
                    accounts: data.accounts.map((i)=>{
                        if(i.id == item.id){
                            return {
                                ...i,
                                status,
                            }
                        }
                        return i
                    })
                }
            }
        })
    }
    const toggle = (item)=>(newState: boolean)=>{
        const fn = toggleAccount(item, newState)
        mutate(fn,{
            rollbackOnError:false,
            revalidate:false,
            optimisticData: {
                ...data,
                accounts: data.accounts.map((i) => {
                    if (i.id == item.id) {
                        return {
                            ...i,
                            status: newState ? 'active' : 'disabled',
                        }
                    }
                    return i
                })
            }
        }).then(()=>{
        })

    }

    return <div>
        <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between">
                <span>Accounts</span>
                {/*<Button onClick={refresh} loading={refreshing} className={"btn btn-li"}><FiRefreshCw /></Button>*/}
            </div>
            {
                !isLoading && data?.accounts && data?.accounts.length === 0 ? <div className={"p-2 text-center"}>You have not connected any accounts</div> : null
            }
            {
                isLoading ? <div className="text-center"><Spinner /></div> : null
            }
            <ul className="list-group list-group-flush">

                {
                    data?.accounts.map((i) => {
                        return <li className={`py-3 px-2 space-between ${i.status === "error" ? 'text-danger' : ''} `} key={i.id}>
                            <span className={"inline-flex gap-3 items-center"}>
                            <RenderPlatformIcon platform={i.platform}/>
                                {i.username || i.name}
                            </span>
                            <span className={"inline-flex items-center gap-2"}>
                            {
                                i.status !== "active" ? <DeleteAccountButton item={i} mutate={mutate} /> : null
                            }
                            <SwitchSmall value={i.status === "active"} onChange={toggle(i)} />
                            </span>
                        </li>
                    })
                }
            </ul>
            <div className="card-footer text-center">
                <Link className={" btn-sm btn btn-outline-primary"} href={"/accounts_connect"}>Connect accounts</Link>
            </div>
        </div>

    </div>
}

function DeleteAccountButton({mutate, item}){
    const [deleting, setDeleting] = useState(false)
    const del = ()=>{
        setDeleting(true)
        if(window.confirm('Are you sure you want to delete this account?')){
            getHttpClient().delete(`/accounts/${item.id}`)
                .then(()=>{
                    setDeleting(false)
                    mutate()
                })
        }
    }
    return <Button onClick={del} loading={deleting} className={"btn btn-sm btn-link text-danger py-0 px-1"}><FiTrash2 style={{fontSize:18}} /></Button>
}


export default SettingsIndex;
